import type { IQuest } from "@/store/apis/questsAPI/quests.types"

const LANG_SUFFIX_RE = /\s(ENG|RU)$/i

export const filterQuestsByLanguage = (
  quests: IQuest[],
  uiLang: string
): IQuest[] => {
  const expected = uiLang === "en" ? "ENG" : "RU"

  return quests.filter((q) => {
    const match = q.title.match(LANG_SUFFIX_RE)
    if (!match) return true
    return match[1].toUpperCase() === expected
  })
}
